import React, { useEffect, useContext, useState, useMemo, useRef } from "react";  
import websocket from "../helpers/WebSocket";
import Context from "../context/Context";
import TeamsContext from "../context/TeamsContext";
import {useNetworkingHooks} from "../helpers/NetworkMessaging";
import { useGameState, useTeamSelectionData } from "../helpers/TeamSelectionHooks";
import { GenericReticule, paperfootballBkgSplash, paperfootballLogo, paperfootballTouchArea } from "../Sprites/ImagesLoader";
import {CoreGameConnectionsHooks} from "../helpers/CoreGameConnections_Hooks";
import { PageBackground, PlayerBanner, PageLanding } from "../Components/PagePrefabs";
import { TeamSelection } from "../Components/TeamSelectionPrefabs";
import { GameplayArea } from "../Components/GameplayPrefabs";


export default function PaperFootball(props){
    const context = useContext(Context);
    const teamsContext = useContext(TeamsContext);

    const useGameStatecontext = useGameState();
    const GameStateRef = useRef();
    GameStateRef.current = useGameStatecontext.GameState;
    const [SliderValue, setSliderValue] = useState(50);

    const {SendSpecificMessageToServer, JoinWaitingRoom, Disconnect, CheckReconnectMessages, Reconnect} = useNetworkingHooks(context.user);
    const {CheckCoreGameConnectionMessages} = CoreGameConnectionsHooks(context, useGameStatecontext, teamsContext);

    useEffect(() => {
        //OnMount Things happen here
        document.title = "Paper Football Controller";

        websocket.AddListener(onPayload);
        window.addEventListener('beforeunload', handleTabClosing);
        //console.log(context.user);
        if(websocket.sessionId === '') Reconnect();
        //SendMessageToServer();
        document.addEventListener("touchmove", preventBehavior, {passive: false});

        //console.log(context.user.playerID);
        return () =>{
            //Unmount things happen here
            websocket.RemoveListener(onPayload);
            window.removeEventListener('beforeunload', handleTabClosing);
            document.removeEventListener("touchmove", preventBehavior, {passive: false});
        }
    }, []);

    const handleTabClosing = () => {
        Disconnect();
    }

    function onPayload(id, payload, senderContext){
        //console.log(`Payload message recieved ${id} ${payload}`)
        CheckCoreGameConnectionMessages(id, payload, senderContext);
        CheckReconnectMessages(id,payload, senderContext);
        switch(id){
         
            default:
                break;
        }
    }
   
    function UpdateSliderValue(value){
        setSliderValue(value);
    }
    function preventBehavior(e) {
        e.preventDefault(); 
    };

    function TrackingPosition(payload){
        //SendSpecificMessageToServer("PaperFootball_Aim", payload);
    }

    function TrackingEnded(coords){
        var msg = {
            coords: coords,
            slider: SliderValue
        }
        SendSpecificMessageToServer("PaperFootball_Fire", msg);
    }
    
    const TouchInfo = {
        bkg: paperfootballTouchArea,
        reticule: GenericReticule,
        sendArray: true, //False slingshot - true swipe
        rate: 15,
        onUpdateTracking: TrackingPosition,
        onTrackingEnd: TrackingEnded

    }

    return (
        <>
        {GameStateRef.current.isOnGameLandingPage ? 
                <PageLanding bkgImage={paperfootballBkgSplash} useLogo Logo={paperfootballLogo} />
                :
                <>
                <PageBackground bkgImage={paperfootballBkgSplash} bkgStyle={{filter: 'blur(.125rem)'}} useBlur useLogo={!GameStateRef.current.joinedGame} Logo={paperfootballLogo}/>            
                <PlayerBanner />
                {!GameStateRef.current.teamsSelected ? 
                    <TeamSelection TeamContext={teamsContext} GameState={GameStateRef.current} smts={(msg) => SendSpecificMessageToServer(msg)} /> 
                    : 
                    <GameplayArea game="Football" Team={teamsContext.Teams.myteam} OpposingTeam={teamsContext.Teams.otherteam} TouchBoxInfo={TouchInfo} useBlur={!GameStateRef.current.myTurn} GetSliderValue={(value) => UpdateSliderValue(value) } Spectating={teamsContext.Teams.myteam === teamsContext.Teams.neutralteam} Logo={paperfootballLogo} />    
                }
                </>
            }
        </>
    );
}

/*
  <PageBackground bkgImage={paperfootballBkgSplash} bkgStyle={{filter: 'blur(.125rem)'}} useBlur useLogo={!GameStateRef.current.joinedGame} Logo={paperfootballLogo}/>
        <PlayerBanner myColor={MyTeam.color}/>
        {!GameStateRef.current.teamsSelected ? 
            <TeamSelection TeamContext={useTeamSelectionDataContext} GameState={GameStateRef.current} smts={(msg) => SendSpecificMessageToServer(msg)} /> 
            : 
            <GameplayArea game="PaperFootball" Team={MyTeam} OpposingTeam={OtherTeam} TouchBoxInfo={TouchInfo} Spectating={Spectating} Logo={paperfootballLogo} />    
        }

*/
